import * as actionTypes from './types';


const INITIAL_KEY_STATE = {
	value: null
};

const INITIAL_STATE = {
	value: {
		visible: false,
		currency: '₹',
		role: 'Reader',
		language: 'en-US',
		packageDetailsData:[],
	},
	set: INITIAL_KEY_STATE,
};


const packageSettingsReducer = (state = INITIAL_STATE, action: any) => {
	const { payload } = action;
	switch (action.type) {
		case actionTypes.SET_DATA:

			return {
				value: {
					...state.value,
					...payload
				}
			};
		default:
			return state;
	}
};

export default packageSettingsReducer;
